import { Vue, Component, Provide, Ref } from 'vue-property-decorator';
import { AppFrame } from '@/enums';
import * as I from '@/interfaces';
import AxAPI from '@/api';
import { AxStorage } from '@/storage';

@Component
export class AxApp extends Vue implements I.AxPageBase {
  private loading = false;
  private appFrame: AppFrame = AppFrame.Blank;
  private accounts?: I.Account;

  dialogList: string[] = [];
  dialogs: I.DialogParam<unknown>[] = [];
  dialogIdx = 0;

  @Ref()
  axModal!: Record<string, Function>;

  @Provide()
  latestInfo: I.AxLatestInfo = {
    controller: 'OTHERS',
    action: 'About',
    groupId: 0
  };

  @Provide()
  getLoginData() {
    return this.accounts;
  }

  @Provide()
  setLoginData(loginData: I.Account) {
    this.accounts = loginData;
  }

  @Provide()
  getLoading() {
    return this.loading;
  }

  @Provide()
  setLoading(sw: boolean) {
    this.loading = sw;
  }

  @Provide()
  getAppFrame() {
    return this.appFrame;
  }

  @Provide()
  setAppFrame(frame: AppFrame) {
    this.appFrame = frame;
  }

  @Provide()
  async showConfirmModal(title: string, text: string, buttons?: string[]) {
    return this.axModal.confirm(title, text, buttons);
  }

  @Provide()
  async showErrorModal(title: string, text: string) {
    return this.axModal.error(title, text);
  }

  @Provide()
  API: AxAPI = new AxAPI();

  @Provide()
  isDevelopment = process.env.NODE_ENV === 'development';

  @Provide()
  getZoneList() {
    if (!this.accounts) return [];
    return this.accounts.listZone;
  }

  @Provide()
  getZoneNames() {
    return this.getZoneList().map(x => x.name);
  }

  @Provide()
  userLogin(res: I.ApiResp<I.Account>) {
    AxStorage.axToken = res.data.token;
    this.setLoginData(res.data);
    this.setAppFrame(AppFrame.Frame);
  }

  @Provide()
  userLogout() {
    this.setAppFrame(AppFrame.Login);
    AxStorage.axToken = '';
  }

  @Provide()
  showDialog(param: I.DialogParam<unknown>) {
    console.log('show dialog');
    console.log(param);
    if (typeof param.props !== 'object') return;
    if (this.dialogList.findIndex(x => x === param.type) === -1) return;

    this.dialogs.push({ ...param, id: this.dialogIdx++ });
  }
}
